<section class="quote-main-section">
    <div class="inner-box">
        <div class="d-flex flex-column text-center">
            <div class="d-flex justify-content-center flex-column">
            <h1 class="heading-1">Create a New Quote</h1>
            <!-- <p class="w-75 text-center m-auto d-flex mt-2 schedule-plan-timer">
        Select the quotation that matches your desired level of detail, from a straightforward estimate to a comprehensive, fully customized proposal.</p> -->
            </div>
            <div class="card-component row">
                <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <div class="card d-flex flex-column justify-content-between gap-4 h-100">
                        <div>
                            <img class="icon" [src]="getImagePath+'Product_Design .svg'" alt="Product Design">
                        </div>
                        <p class="quote-detail">Product Design<br/> and Development</p>
                        <button class="btn product_design" (click)="OpenCreateProjectModal(create_project)">Create</button>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <div class="card d-flex flex-column justify-content-between gap-4 h-100 not-allowed-filter">
                        <div>
                            <img class="icon" [src]="getImagePath+'Prototyping.svg'" alt="Product Design">
                        </div>
                        <p class="quote-detail">DFM and Rapid<br/> Prototyping</p>
                        <button class="btn secondary-btn">Create</button>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <div class="card d-flex flex-column justify-content-between gap-4 h-100">
                        <div>
                            <img class="icon" [src]="getImagePath+'Product _Assembly.svg'" alt="PCBA Manufacturing">
                        </div>
                        <p class="quote-detail">Electronics & Manufacturing, or Full Product Assembly</p>
                        <button class="btn primary-btn"(click)="routeTo('m-quotation')">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<ng-template #create_project let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-centered m-0">
        <div class="edit-project-dialog modal-content">
            <div class="d-flex flex-column align-items-center relative">
                <img class="logo" [src]="getImagePath+'edit-project.svg'" alt="Logo" height="40" width="40">
                <div class="improved-page-label">Create Project</div>
                <button type="button" class="close-btn btn" aria-label="Close" (click)="d('Cross click')">
                    <img [src]="getImagePath+'close-icon.svg'" alt="Close" height="15" width="15">
                </button>
            </div>
            <div class="form-container">
                <form class="custom-create-project-form" id="createProjectForm" [formGroup]="createProjectForm">
                    <div class="form-control-box bottom-spacing">
                        <label for="vProjectName" class="label">Project Name<span class="text-danger">*</span></label>
                        <div>
                            <mat-form-field appearance="outline" class="improved-input w-100">
                              <input matInput id="name" placeholder="Enter Project Name" formControlName="vProjectName">
                            </mat-form-field>
                          </div>
                          <div class="input-details-box no-mat-input justify-content-end">
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(createProjectForm, 'vProjectName', 'required')">
                            Project Name is required.
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(createProjectForm, 'vProjectName', 'maxlength')">
                            Must not exceed 100 characters.
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(createProjectForm, 'vProjectName', 'pattern')">
                            Please enter valid name.
                          </mat-error>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-end mt-3"> 
                        <button class="btn btn-primary improved-add-btn" [disabled]="!createProjectForm.dirty || createProjectForm.invalid"
                            [ngClass]="{'disabled-button': !createProjectForm.dirty || createProjectForm.invalid}" (click)="CreateProject()">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>